.field-hint {
  font-size: 0.875rem;
}
